"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
const OptionsButton_1 = __importDefault(require("../../atoms/OptionsButton"));
const SpursSizeButton_1 = __importDefault(require("../../atoms/SpursSizeButton"));
const Tooltip_1 = require("../../atoms/Tooltip");
const SpursSettingsPopup_1 = __importDefault(require("../SpursSettingsPopup"));
const SizesOptions_1 = __importDefault(require("../SizesOptions"));
const bridge_1 = require("@completeanatomy/bridge");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const TooltipWithModal_1 = __importDefault(require("../../atoms/TooltipWithModal"));
const hooks_1 = require("../../hooks");
const providers_1 = require("../../providers");
const spursOptionsHandlers_1 = require("../../utils/spursOptionsHandlers");
function ToolsSpursOptionsPanel({ className }) {
    const [isSettingsOpen, toggleSettings] = (0, ui_1.useToggleState)(false);
    const [isSizeOpen, toggleSize] = (0, react_1.useState)(false);
    const buttonRef = (0, react_1.useRef)();
    const bridge = (0, bridge_1.useBridge)();
    const containerRef = (0, react_1.useRef)(null);
    const [, setOptions] = (0, react_1.useState)({
        size: 2,
        particleSize: 0,
        type: bridge_schema_1.ToolType.SpursCluster,
    });
    const tools = (0, providers_1.useToolsService)();
    const spursManager = tools === null || tools === void 0 ? void 0 : tools.getThreeDToolManager();
    const { size, type, particleSize } = (0, hooks_1.useSpursOptions)();
    const onChange = (changedOptions) => (0, spursOptionsHandlers_1.handleSpursOptionChange)(changedOptions, setOptions, bridge, particleSize, size, spursManager);
    const setSize = (value) => {
        onChange({ size: value });
    };
    const onClickOutside = () => {
        toggleSize(false);
    };
    (0, ui_1.useOutsideClick)(containerRef, onClickOutside, [], {
        active: isSizeOpen,
        stopPropagation: true,
    });
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ui_1.Overlay, { shown: isSizeOpen, zIndex: 0, "data-e2e": 'ToolsSpursOptionsPanel_Overlay' }), (0, jsx_runtime_1.jsxs)(Container, { ref: containerRef, className: className, "data-e2e": 'ToolsSpursOptionsPanel_Container', children: [(0, jsx_runtime_1.jsx)(SettingsButton, { forwardedRef: buttonRef, sizeActive: isSizeOpen, onClick: toggleSettings, "data-e2e": 'ToolsSpursOptionsPanel_SettingsButton', children: (0, jsx_runtime_1.jsx)(ButtonIcon, { name: ui_1.Icons.Settings, "data-e2e": 'ToolsSpursOptionsPanel_ButtonIcon' }) }), (0, jsx_runtime_1.jsx)(SettingsTooltip, { position: Tooltip_1.TooltipPosition.Top, padding: { width: 0, height: 0 }, isOpen: isSettingsOpen, onToggle: toggleSettings, targetElement: buttonRef.current, "data-e2e": 'ToolsSpursOptionsPanel_SettingsTooltip', children: (0, jsx_runtime_1.jsx)(SpursSettingsPopup_1.default, { onChange: onChange, particleSize: particleSize || 0, type: type, "data-e2e": 'ToolsSpursOptionsPanel_SpursSettingsPanel' }) }), (0, jsx_runtime_1.jsxs)(SizeContainer, { active: isSizeOpen, "data-e2e": 'ToolsSpursOptionsPanel_SizeContainer', children: [(0, jsx_runtime_1.jsx)(SizesContainer, { cube: false, sizes: [0, 1, 2, 3], currentSize: size || 0, active: isSizeOpen, onSelect: setSize, "data-e2e": 'ToolsSpursOptionsPanel_SizesContainer' }), (0, jsx_runtime_1.jsx)(SpursSizeButton_1.default, { size: size || 0, active: isSizeOpen, onClick: () => toggleSize(!isSizeOpen), "data-e2e": 'ToolsSpursOptionsPanel_SpursSizeButton' })] })] })] }));
}
exports.default = ToolsSpursOptionsPanel;
const Container = styled_components_1.default.div `
  position: relative;

  display: flex;
`;
const SettingsButton = (0, styled_components_1.default)(OptionsButton_1.default) `
  margin: 0 20px 0 0;

  transform: translateY(${({ sizeActive }) => (sizeActive ? '320%' : 0)});

  transition: transform 0.2s ease-in;
`;
const ButtonIcon = (0, styled_components_1.default)(ui_1.Icon) `
  width: 35px;
  height: 35px;
`;
const SettingsTooltip = (0, styled_components_1.default)(TooltipWithModal_1.default) `
  border-radius: 8px;
`;
const SizeContainer = styled_components_1.default.div `
  position: relative;

  transform: translateX(${({ active }) => (active ? '-40px' : 0)});

  transition: transform 0.2s ease-in;
`;
const SizesContainer = (0, styled_components_1.default)(SizesOptions_1.default) `
  position: absolute;
  top: 0;
  left: 0;

  padding-left: 80px;
`;
